<template>
  <div>
    <div class="banner innerpageBanner">
      <div class="container">

        <div class="caption">
          <div>
            <h1>品鉴报告</h1>
            <p>有关勃艮第产区的品鉴报告</p>
          </div>
        </div>
      </div>
      <img
        src="https://image.insideburgundy.cn/insideburgundy/20190523/b469e31e39414cf8a9a46a214479d5e4.png"
        alt="品鉴报告"
        class="cover-image"
      >
    </div>

    <div class="container">
      <searchBox/>
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name">品鉴报告</span>
            <meta property="position" content="2">
          </span>
        </div>
      </div>
    </div>

    <section class="innerPage">

    <div class="container">
      <rightMenu  title="分类"  :menudata='rightListdata' @OnClick='rightClick'/>

      <div class="leftCol tastingIntro">
        <p><h2>Inside Burgundy品鉴报告</h2></p>
        <p class="p1">
          <span
            class="s1"
          >Inside Burgundy中文网的一项重要工作内容是向读者提供品鉴报告。每一篇品鉴报告都是一篇独立的内容，同时也是网站不断扩张的品酒笔记数据库中的一部分。您可以随时查阅数据库中的品酒笔记，每篇品鉴报告都有一个主题，我们会在下文中解释
           “<a href="#/Appraisalreport">品鉴报告介绍</a>”。
          </span>
        </p>
        <p> <h2>Inside Burgundy品鉴笔记</h2></p>
        <p class="p1">
          <span class="s1">
            每款酒都对应一个分数和一个星级，分数和星级请参考如下链接 “
            <a href="#/Introductionpage">评分制度介绍</a>
            ”。
          </span>
        </p>
      <div class="gridBoxes two small">
        <ul>
          <li>
            <div class="content">
              <div class="img">
                <img
                  src="https://image.insideburgundy.cn/insideburgundy/20190523/9da9b29c4609476db91febe13b41e306.png"
                  alt="An Introduction to Tasting Notes"
                  class="cover-image"
                >
              </div>
              <div class="discription">
                <h6>评分制度介绍</h6>
                <p>我们如何定义一款出色的勃艮第酒？点击这里了解更多</p>
              </div>
              <a href="#/Introductionpage" target class="readmore">阅读更多</a>
            </div>
          </li>

          <li>
            <div class="content">
              <div class="img">
                <img
                  src="https://image.insideburgundy.cn/insideburgundy/20190523/1efbe93b268849deb2c51236bd52c86c.png"
                  alt="An Introduction to Tasting Reports"
                  class="cover-image"
                >
              </div>
              <div class="discription">
                <h6>品鉴报告介绍</h6>
                <p>品鉴报告的几种常见形式包括：桶边品鉴、Burgfest、1020品鉴，风土垂直、平行品鉴，点击这里了解更多</p>
              </div>
              <a href="#/Appraisalreport" target class="readmore">阅读更多</a>
            </div>
          </li>
        </ul>
        <!-- Top 3 blocks -->
      </div>

      <div class="gridBoxes three small">
        <h2 class="animate fadeInUp triggeredCSS3">最新报告</h2>
        <ul>
          <li class="animate fadeInUp triggeredCSS3" v-for="item in latestList" :key="item.id">
            <div class="content">
              <a :href="'#/Qualification?id='+item.id">
                <div class="img">
                  <img :src="item.image" alt="Frost Patrol: Sunday April 14th" class="cover-image">
                </div>
              </a>
              <div class="discription">
                <h6>
                  <a :href="'#/Qualification?id='+item.id">{{item.title}}</a>
                </h6>
                {{item.introduction}}
              </div>
              <a :href="'#/Qualification?id='+item.id" class="readmore">阅读更多</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
    </section>
  </div>
</template>

<script>
import searchBox from "../template/search";
import ajax from "../ajax";
import rightMenu from '../template/rightMenu'
export default {
  data() {
    return {
      latestList: [],
      rightListdata:{}
    };
  },
  components: {
    rightMenu,
    searchBox
  },
  created() {
    this.getlatestList();
    this.getRightdata()
  },
  methods: {
    getRightdata(){
      ajax.getReportCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data){
      if(!data.child&&data.id)
        this.$router.push({path:'/Qualification',query:{id:data.id}})
    },
    getlatestList() {
      ajax.getlatestList().then(res => {
        this.latestList = res.data;
      });
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Appraisal.vue